const IconUnlocked = () => {
    return (
        <svg
            width="30"
            height="31"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="6.51831"
                y="14.4368"
                width="16.9633"
                height="11.0152"
                rx="2.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M15 18.8822L15 21.0064"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M9.7494 13.8389L9.7494 10.6128C9.7494 7.90061 11.9481 5.7019 14.6603 5.7019L15.5404 5.7019C17.7666 5.7019 19.5713 7.50659 19.5713 9.73279V9.73279"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default IconUnlocked;
